<template>
  <!-- 大件订单看板 -->
  <div class="Box" ref="boxRef">
    <div style="width: 100%" class="selectClass" ref="selectClassRef">
      <el-form :model="queryForm">
        <el-row type="flex" justify="start" style="flex-wrap: wrap;align-items: center">
          <el-col :span="10">
            <el-form-item :label="$t('collectionCenter.CreationTime')">
              <el-date-picker
                v-model="timeValue"
                :clearable="false"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('collectionCenter.EndTime')"
                range-separator="~"
                :start-placeholder="$t('collectionCenter.StartTime')"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                style="width: 100%"
                @change="dateChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--客户名称-->
            <el-form-item :label="$t('collectionCenter.CustomerName')">
              <el-select
                v-model="queryForm.customerIdList"
                :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
                style="width: 100%;"
                size="small"
                filterable
                multiple
                clearable
                remote
                reserve-keyword
                :remote-method="getCustomerOption"
                @clear="getCustomerOption('')"
              >
                <el-option
                  v-for="item in customerOption"
                  :key="item.id"
                  :label="item.customerAlias + '（' + item.username + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="text-align: center">
            <!--搜索-->
            <el-button
              size="mini" type="primary" @click="search"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              size="mini" style="margin-left: 20px" type="info"
              @click="resetData"
            >{{ $t('newOrder.reset') }}
            </el-button>
            <el-radio-group
              v-model="queryForm.isTest"
              size="mini"
              style="margin-left: 20px"
              @change="search"
            >
              <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button><!--正式-->
              <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button><!--测试-->
            </el-radio-group>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="container">
      <div class="left-section">
        <div class="top-left">
          <div class="titleClass">{{ $t('collectionCenter.orderOverview') }}</div><!-- 订单总览 -->
          <el-row>
            <el-col :span="8">
              <div class="tl">
                <span class="tl-title">{{ $t('collectionCenter.totalOrders') }}</span><!-- 订单总量 -->
                <span class="tl-sum">{{ orderTotal.totalOrders }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="tl">
                <span class="tl-title">{{ $t('navbar.totalNumber') }}</span><!-- 总件数 -->
                <span class="tl-sum">{{ orderTotal.totalPieces }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="tl">
                <span class="tl-title">{{ $t('collectionCenter.customerOrderCount') }}</span><!-- 下单客户数 -->
                <span class="tl-sum">{{ orderTotal.customerCount }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="bottom-left">
          <div class="titleClass">{{ $t('collectionCenter.positiveWaybillMonitoring') }}</div><!-- 正向在途运单监控 -->
          <div v-if="optionsIsShow" style="width: 100%;">
            <echarsBox :options="options" />
          </div>
          <div v-else>
            <el-empty :image-size="200" />
          </div>
        </div>
      </div>
      <div class="right-section">
        <div class="titleClass">{{ $t('collectionCenter.waybillMonitoring') }}</div><!-- 运单监控 -->
        <div v-if="progressList.length > 0" class="right-box-class">
          <el-row
            v-for="(item, ind) in progressList" :key="ind"
            type="flex" justify="flex-start" style="flex-wrap: wrap;align-items: center"
          >
            <el-col :span="5" class="status-name">{{ item.waybillStatusName }}</el-col>
            <el-col :span="16" class="progress-bar">
              <el-progress
                :percentage="item.countBar"
                :color="item.waybillStatus === 2 ||
                  item.waybillStatus === 11 ||
                  item.waybillStatus === 17 ||
                  item.waybillStatus === 18 ||
                  item.waybillStatus === 15 ? '#cc0000' : '#00a121'"
                :show-text="false"
                class="custom-progress"
              /><!-- 将【待揽收】、【问题件】、【网点退回】、【退仓到件】、【退件中】这5个状态的条形用红色标识 -->
            </el-col>
            <el-col :span="3" class="bar-num">{{ item.count }}</el-col>
          </el-row>
        </div>
        <div v-else>
          <el-empty :image-size="200" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryCustomerName,
  getCargoOrderSummary,
  getCargoWaybillMonitor,
  getCargoTransitMonitor
} from '@/api/bulkyExpress';

import dayjs from 'dayjs';

export default {
  name: 'OversizeOrderDashboard',
  components: {
    echarsBox: () => import('./component/echarts.vue')
  },
  data() {
    return {
      optionsIsShow: false,
      queryForm: {
        startTime: '',
        endTime: '',
        customerIdList: [],
        isTest: 1
      },
      timeValue: [],
      customerOption: [],
      orderTotal: {
        totalOrders: 0,
        totalPieces: 0,
        customerCount: 0
      },
      options: {},
      // 将【待揽收】、【问题件】、【网点退回】、【退仓到件】、【退件中】这5个状态的条形用红色标识
      progressList: []
    };
  },
  created() {
    this.getCustomerOption('');
    this.default();
    this.search();
  },
  mounted() {
    window.addEventListener('resize', this.setBoxHeight);
    this.$nextTick(() => {
      this.setBoxHeight();
    });
  },
  methods: {
    setBoxHeight() {
      const selectClassEl = this.$refs.selectClassRef;
      const boxEl = this.$refs.boxRef;

      if (selectClassEl && boxEl) {
        const height = selectClassEl.offsetHeight;
        boxEl.style.height = `calc(100% - ${height}px)`;
      }
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.startTime = '';
        this.queryForm.endTime = '';
        return;
      }
      this.queryForm.startTime = val[0];
      this.queryForm.endTime = val[1];
    },
    // 获取客户选项
    getCustomerOption(name) {
      queryCustomerName(name).then(res => {
        if (res.code === 200) {
          this.customerOption = res.data;
        }
      });
    },
    resetData() {
      this.default();
    },
    default() {
      const d = new Date();
      const end = dayjs(d).format('YYYY-MM-DD 23:59:59');
      const start = dayjs(d).subtract(6, 'day').format('YYYY-MM-DD 00:00:00');
      this.timeValue = [start, end];
      this.queryForm = {
        startTime: start,
        endTime: end,
        customerIdList: [],
        isTest: 1
      };
    },
    search() {
      if (!this.queryForm.startTime || !this.queryForm.endTime) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime')); // 请选择日期时间
        return;
      }
      getCargoOrderSummary(this.queryForm).then(res => {
        if (res.code === 200) {
          // 获取订单总览统计
          this.orderTotal = {
            totalOrders: res.data.totalOrders,
            totalPieces: res.data.totalPieces,
            customerCount: res.data.customerCount
          };
        }
      });
      getCargoWaybillMonitor(this.queryForm).then(res => {
        if (res.code === 200) {
          // 获取运单状态统计
          const total = res.data.reduce((acc, curr) => acc + curr.count, 0);
          this.progressList = res.data.map(item => {
            return {
              ...item,
              countBar: parseFloat(((item.count / total) * 100).toFixed(2))
            };
          });
        }
      });
      getCargoTransitMonitor(this.queryForm).then(res => {
        if (res.code === 200) {
          // 获取在途运单按州统计
          const newData = res.data;
          this.optionsIsShow = res.data.length > 0;
          this.options = {
            tooltip: {},
            xAxis: {
              type: 'category',
              data: newData.map(item => item.state),
              axisLabel: {
                width: '100%'
              }
            },
            yAxis: {
              type: 'value'
            },
            series: [{
              name: this.$t('home.homeCount'),
              type: 'bar',
              data: newData.map(item => item.count),
              barWidth: 20,
              itemStyle: {
                color: '#26af42'
              }
            }]
          };
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.Box{
  padding: 20px;
  padding-left: 0;
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.selectClass ::v-deep .el-form-item{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 0 !important;
}
.selectClass ::v-deep .el-form-item__content{
  width: 100%;
  margin-left: 0 !important;
}
.selectClass ::v-deep .el-select{
  width: 100%;
}
.selectClass ::v-deep .el-form-item__label{
  padding: 0;
  line-height: 16px;
  white-space: nowrap;
  margin-left: 0 !important;
  margin-right: 5px;
}
.container {
  margin-top: 20px;
  display: flex;
  flex-grow: 1;
  height: 100%; /* 确保高度继承正确 */
  gap: 7px; /* 设置间距为1px */
  background-color: #e1e1e1; /* 用作间隔颜色 */
  .left-section {
    display: flex;
    flex-direction: column;
    width: 60%;
    gap: 8px;
    background-color: #e1e1e1;
    .top-left, .bottom-left {
      flex: 1;
      background-color: white; /* 隔间背景色与间隔线区分开 */
      border: none;
      padding-left: 20px;
      box-sizing: border-box;
    }
    .tl {
      display: flex;
      flex-direction: column;
      margin: 20px;
      height: 100%;
      border: 1px solid #3fb858;
      border-radius: 5px;
      padding-top: 5px;
      padding-left: 3px;
      box-sizing: border-box;
      .tl-title {
        color: #000;
        font-size: 14px;
        font-weight: bold;
      }
      .tl-sum {
        height: 50px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #00a121;
        font-size: 15px;
        font-weight: bold;
      }
    }
    .bottom-left {
      padding-top: 10px;
      box-sizing: border-box;
    }
  }
  .right-section {
    flex: 1;
    background-color: white;
    .titleClass {
      margin-left: 20px;
      margin-bottom: 20px;
    }
  }
  .titleClass {
    display: inline-block;
    color: #fff;
    font-size: 14px;
    background-image: linear-gradient(to right, #13972e, #f3faf4);
    padding: 1px 30px 1px 10px;
    box-sizing: border-box;
    min-width: 170px;
  }
}
.right-box-class {
  padding: 0 20px;
  padding-right: 0;
  box-sizing: border-box;
}
.right-box-class ::v-deep .el-col {
  font-size: 14px;
  margin-bottom: 18px;
}
.right-box-class ::v-deep .el-col.status-name, .right-box-class ::v-deep .el-col.bar-num {
  word-break: break-all;
  word-wrap: break-word;
}
.right-box-class ::v-deep .el-col.status-name {
  line-height: 15px;
  text-align: right;
}
.right-box-class ::v-deep .el-col.bar-num {
  text-align: center;
}
.right-box-class ::v-deep .el-col.progress-bar {
  padding: 0 20px;
}
.custom-progress ::v-deep .el-progress-bar__outer {
  background-color: transparent !important; /* 移除默认背景色 */
}
</style>
